import React from "react";
import { useLocation } from 'react-router-dom';
export default function ComingSoon() {
  const location = useLocation();
  const category = location.state?.category;
  return (
    <div style={styles.wrapper}>
      <h1 style={styles.title}>Coming Soon {category.name == 'Credit Card' ? 'From August 2026' : 'From August 2026'}</h1>

    </div>
  );
}

const styles = {
  wrapper: {
    height: "100vh",
    background: "linear-gradient(to right, #00695c, #009688)",
    color: "#fff",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    padding: "20px",
  },
  title: {
    fontSize: "3rem",
    marginBottom: "20px",
  },
  subtitle: {
    fontSize: "1.5rem",
    marginBottom: "10px",
  },
  date: {
    fontSize: "1.2rem",
    fontStyle: "italic",
  },
};
